import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { IUpdateMealtimeDetailsRequest, updateMealtimeDetails } from '../../api/updateMealtimeDetails';

export const useUpdateMealtime = (menuId: string, mealtimeId: string, onSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(
    (requestBody: IUpdateMealtimeDetailsRequest) => updateMealtimeDetails(menuId, mealtimeId, requestBody),
    {
      onSuccess: async (_, requestBody) => {
        showSnackbar({
          message: `Successfully updated ${requestBody.name}`,
          status: SnackbarStatus.SUCCESS,
        });

        await queryClient.refetchQueries({ queryKey: [menuId, 'mealtimes'] });
        onSuccess();
      },
      onError: () => {
        showSnackbar({
          message: 'Something went wrong whilst updating a mealtime',
          status: SnackbarStatus.ERROR,
        });
      },
    },
  );
};
